import { enqueueFeEvent, initFeTelemetryUnloadFlush, setFeTelemetryNativeFetch } from './queue';
import { initFeBehaviorTracking } from './behavior';
import { normalizeApiPath, shouldTrackApiPath } from './routeContext';
import type { FeApiEvent } from './types';

export { enqueueStudentAction, reportStudentAction } from './studentActions';
export { reportFeInfo, trackRouteChange } from './behavior';
export { flushFeTelemetry } from './queue';
export type { FeActionEvent, FeTelemetryEvent } from './types';

export function recordFeApiTiming(params: {
  method: string;
  path: string;
  status?: number;
  durationMs: number;
  ok: boolean;
  requestId?: string | null;
}) {
  if (!shouldTrackApiPath(params.path)) {
    return;
  }

  const event: FeApiEvent = {
    k: 'api',
    t: new Date().toISOString(),
    m: params.method.toUpperCase(),
    p: params.path.split('?')[0],
    pt: normalizeApiPath(params.path),
    s: params.status,
    d: Math.max(0, Math.round(params.durationMs)),
    ok: params.ok,
    rid: params.requestId || undefined,
  };
  enqueueFeEvent(event);
}

let initialized = false;

export function initFeTelemetry(nativeFetch?: typeof fetch) {
  if (initialized || typeof window === 'undefined') {
    return;
  }
  initialized = true;
  if (nativeFetch) {
    setFeTelemetryNativeFetch(nativeFetch);
  }
  initFeTelemetryUnloadFlush();
  initFeBehaviorTracking();
}
